export default "__VITE_ASSET__DZMsS_78__"